import { PublicClientApplication } from "@azure/msal-browser";

export async function getCurrentToken(msalInstance) {
    const acquireAccessToken = async () => {
        const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
        const accounts = msalInstance.getAllAccounts();

        if (!activeAccount && accounts.length === 0) {
            /*
            * User is not signed in. Throw error or wait for user to login.
            * Do not attempt to log a user in outside of the context of MsalProvider
            */
            return null;
        }
        const request = {
            scopes: [ process.env.REACT_APP_UI_API_Audience ],
            account: activeAccount || accounts[0]
        };

        try {
            const authResult = await msalInstance.acquireTokenSilent(request);
            console.debug("Access token acquired through slient", authResult.accessToken);
            return authResult.accessToken;
        } catch (error) {
            // If silent acquisition fails, try acquiring token through popup or redirect
            try {
                const authResult = await msalInstance.acquireTokenPopup(request);
                console.debug("Access token acquired through popup", authResult.accessToken);
                return authResult.accessToken;
            } catch (error) {
                console.error("Error acquiring token:", error);
                return null;
            }
        }
    };

    var token = null;

    if (typeof window !== 'undefined') {
        token = await acquireAccessToken();
    }

    return token;
}